import React, { Component } from "react";
import ReactDOM from "react-dom";
import './index.css';
//import App from './App';
import * as serviceWorker from './serviceWorker';

import '@fortawesome/fontawesome-free/css/all.min.css';
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import { MDBBtn, MDBInput, MDBFormInline, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBChip, MDBBadge, MDBContainer, MDBRow, MDBCol} from "mdbreact";
//import "./index.css";

// Import Firebase as well as any extensions. In this case we're just adding on Firestore (our database)
import firebase from "firebase/app";
import "firebase/firestore";

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCxxRVVIzQM3Vjuh8dwEsNc-CnQYD14F1g",
    authDomain: "firelist-be52d.firebaseapp.com",
    databaseURL: "https://firelist-be52d.firebaseio.com",
    projectId: "firelist-be52d",
    storageBucket: "firelist-be52d.appspot.com",
    messagingSenderId: "283705661029"
};
firebase.initializeApp(config);

// This prevents a warning message for changes to firestore timestamp syntax in the console
// Firestore is still in Beta - in the future this won't be necessary
const firestore = firebase.firestore();
const settings = { /* your settings... */ timestampsInSnapshots: true };
firestore.settings(settings);

class App extends Component {
    constructor(props) {
    super(props);
    this.state = {
        modal: false,
        events: [],
        title: "",
        description: ""
    };
    }

    getTasks = () => {
      firebase
        .firestore()
        .collection("tasks")
        .onSnapshot(
          querySnapshot => {
            this.setState({ events: [] })
            querySnapshot.forEach(doc => {
              let docInfo = doc.data()
              docInfo.id = doc.id
              this.setState({
                events: [...this.state.events, docInfo]
              });
            });
          }
        )
    };

    componentDidMount() {
      this.getTasks();
    }
    /*
    dataIndex = () => {
      return this.state.data.map(task => {
        return (
          <div key={task.id}>
            <strong>Title: </strong>
            {task.title} <strong>Description: </strong> {task.description}
          </div>
        );
      });
    };
    */

    handleSubmit = event => {
      event.preventDefault();

      this.toggleModal()

      // Add a new document with a generated id.
      firebase
        .firestore()
        .collection("tasks")
        .add({
          title: this.state.title,
          description: this.state.description
        })
        .then(this.setState({ data: [] })) // Clears the current data
        .then(() => this.getTasks())
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    };

    handleChange = event => {
      this.setState({
        [event.target.name]: event.target.value
      });
    };

    dataForm = () => {
      return (
        <form>
        {/*
          <input
            type="text"
            name="title"
            placeholder="New Task"
            onChange={this.handleChange}
          />
          <input
            type="text"
            name="description"
            placeholder="Task Description"
            onChange={this.handleChange}
          />
          */}
          <MDBInput
            name="title"
            label="Question (<10 words)"
            icon="question-circle"
            group
            type="text"
            onChange={this.handleChange}
            //getValue={this.handleChange}
          />
          <MDBInput
            name="description"
            label="Description"
            icon="sticky-note"
            group
            type="textarea"
            onChange={this.handleChange}
            //getValue={this.handleChange}
          />
          <MDBModalFooter className="justify-content-center">
          {/*<button type="submit" onClick={this.handleSubmit}>
            {" "}
            Submit{" "}
          </button>*/}
          <MDBBtn
              color="info"
              onClick={this.handleSubmit}>
              Add
          </MDBBtn>
          </MDBModalFooter>
          {/*
          <MDBModalFooter className="justify-content-center">
          <MDBBtn
              color="info"
              onClick={() => {
              this.toggleModal();
              this.handleSubmit();
              }}
          >
              Add
          </MDBBtn>
          </MDBModalFooter>*/}
        </form>
      );
    };

    addEvent = () => {
    var newArray = [...this.state.events];
    newArray.push({
        id: newArray.length ? newArray[newArray.length - 1].id + 1 : 1,
        title: this.state.title,
        description: this.state.description
    });
    this.setState({ events: newArray });
    this.setState({
        title: "",
        description: ""
    });
    };
    handleInputChange = inputName => value => {
    const nextValue = value;
    this.setState({
        [inputName]: nextValue
    });
    };
    handleDelete = eventId => {
    //const events = this.state.events.filter(e => e.id !== eventId);
    //this.setState({ events });
    firebase.database().ref('tasks').child(eventId).remove();
    };
    toggleModal = () => {
    this.setState({
        modal: !this.state.modal
    });
    };
    render() {
    return (
        <React.Fragment>
        <MDBContainer>
            <MDBRow>

            <MDBCol md="8">
                <div>
                <h2 className="text my-3">armati.co</h2>
                <MDBCol md="12">
                <div class="d-flex">
                  <input className="form-control" type="text" placeholder="[disabled] Post/find a question, search for #hashtags" aria-label="Search" disabled/>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" className="close" aria-label="Close" onClick={this.toggleModal}>
                    <span aria-hidden="true"><div><MDBIcon far icon="plus-square" />question</div></span>
                  </button>
                </div>
                </MDBCol>
                <br />
                </div>
                <div id="events">
                {this.state.events.map(task => (
                    <Event
                    key={task.id}
                    id={task.id}
                    //time={event.time}
                    title={task.title}
                    //location={event.location}
                    description={task.description}
                    //onDelete={this.handleDelete}
                    />
                ))}
                </div>

            </MDBCol>
            <MDBCol md="3">
                <h3 className="text-uppercase my-3">Q&A class rank</h3>
                <ul class="list-group">
                  <li class="list-group-item">1. Sean Paul</li>
                  <li class="list-group-item">2. Elon Musk</li>
                  <li class="list-group-item">...</li>
                  <li class="list-group-item">9. <b>Alex Orr (You)</b></li>
                  <li class="list-group-item">...</li>
                </ul>

                <p>
                <br />
                <b>armati.co</b> is the best online platform for collaborative and anonymous class Q&A. Use the power of the web to get answers quickly and well-structured.
                </p>
            </MDBCol>
            </MDBRow>
        </MDBContainer>
        <MDBModal isOpen={this.state.modal} toggle={this.toggleModal}>
            <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.toggleModal}
            >
            Ask a new Question in [CS433]
            </MDBModalHeader>
            <MDBModalBody>
                {this.dataForm()}
                {/*
                <form className="mx-3 grey-text">
                    <MDBInput
                      name="time"
                      label="Time"
                      icon="clock"
                      hint="12:30"
                      group
                      type="text"
                      getValue={this.handleInputChange("time")}
                    />
                    <MDBInput
                      name="title"
                      label="Title"
                      icon="edit"
                      hint="Briefing"
                      group
                      type="text"
                      getValue={this.handleInputChange("title")}
                    />
                    <MDBInput
                      name="location"
                      label="Location (optional)"
                      icon="map"
                      group
                      type="text"
                      getValue={this.handleInputChange("location")}
                    />
                    <MDBInput
                      name="description"
                      label="Description (optional)"
                      icon="sticky-note"
                      group
                      type="textarea"
                      getValue={this.handleInputChange("description")}
                    />
                  </form>
                  */}

            </MDBModalBody>
        </MDBModal>
        </React.Fragment>
    );
    }
}
class Event extends Component {
    render() {
    return (
        <React.Fragment>
        <div className="media mt-1">
            <h3 className="h3-responsive font-weight-bold">

            </h3>
            <div className="media-body mb-3 mb-lg-3">
            {/*
            <MDBBadge
                color="danger"
                className="ml-2 float-right"
                onClick={() => this.props.onDelete(this.props.id)}
            >

                -
            </MDBBadge>
            */}
            <div class="card">

              <div class="card-body">
                <h5 class="card-title">{this.props.title}</h5>
                <h6 class="card-subtitle mb-2 text-muted">Posted by Elon Musk in CS433 · 1 hour ago</h6>
                <p class="card-text">{this.props.description && (
                    <p class="text-wrap"><h6>
                    {this.props.description} ...
                    </h6>
                    </p>
                )}</p>
                <div class="d-flex justify-content-between">
                  <div class="p-2">
                    <p><a><i class="far fa-thumbs-up"></i> 5</a> &nbsp;
                    <MDBBadge color="light z-depth-0">#exam2</MDBBadge> &nbsp;
                    <MDBBadge color="light z-depth-0">#cs433</MDBBadge>
                    </p>
                  </div>
                  <div class="p-2">
                    8 replies
                    </div>
                </div>
                <hr />
              <div class="card-text text-muted clearfix">
                <div class="d-flex justify-content-between">
                  <div class="p-2">
                  <a>Expand 7 more replies</a>
                  </div>

                  <div class="p-2">
                    <MDBBadge pill color="amber z-depth-0"><MDBIcon icon="check-circle" className="white-text pr-1"/> instructor</MDBBadge>
                    </div>
                </div>
                <div class="d-flex">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Martin_Vetterli_%28cropped%29.jpg/230px-Martin_Vetterli_%28cropped%29.jpg" alt="Avatar" class="md-avatar rounded-circle" />
                  <div class="card-header wrap-text">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed faucibus vel dolor id consectetur. Sed pellentesque nisi at purus efficitur, et vulputate orci iaculis.
                  </div>
                </div>
              </div>
              </div>
            </div>
            <hr className="hr-bold my-2" />
            </div>
        </div>
        </React.Fragment>
    );
    }
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
